import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";
import {
  AllCategoryInterface,
  CreateUpdateCategoryInterface,
} from "../models/category/category";
import { SuccessDto } from "../models/success-dto";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  constructor(private http: HttpClient) {}

  getAllCategoryNames(): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.APP_PORT + Constants.CATEGORY_ENDPOINT}/allCategoriesNames`
    );
  }

  getAllCategories(): Observable<AllCategoryInterface[]> {
    return this.http.get<AllCategoryInterface[]>(
      `${environment.APP_PORT + Constants.CATEGORY_ENDPOINT}/allCategories`
    );
  }

  createCategory(
    category: CreateUpdateCategoryInterface
  ): Observable<SuccessDto> {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.CATEGORY_ENDPOINT}/create`,
      category
    );
  }

  updateCategory(
    category: CreateUpdateCategoryInterface,
    oldName: string
  ): Observable<SuccessDto> {
    return this.http.patch<SuccessDto>(
      `${environment.APP_PORT + Constants.CATEGORY_ENDPOINT + "/" + oldName}`,
      category
    );
  }

  deleteCategory(categoryName: string): Observable<SuccessDto> {
    return this.http.delete<SuccessDto>(
      `${environment.APP_PORT + Constants.CATEGORY_ENDPOINT}/` + categoryName
    );
  }
 
}
